__turbopack_context__.v({
  "copy": "iIY87G_copy",
  "footer": "iIY87G_footer",
  "footerCta": "iIY87G_footerCta",
  "title": "iIY87G_title",
});
